<template>
    <el-dialog title="Modifier le prix" v-loading="loader" :visible.sync="display" width="50%">
        <span>Changer le pix pour les {{ items_selected }} produits selectionnés</span>
        <el-form class="row formPrice" ref="form" :model="form">
            <el-form-item prop="price" label="Nouveau prix">
                <el-input-number v-model="form.price" controls-position="right" :min="0"></el-input-number>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-switch active-text="Syncronisé ?" v-model="form.sync" ></el-switch>
            <el-button @click="display = false">Annuler</el-button>
            <el-button type="primary" @click="action">Enregistrer</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    data() {
        return {
            display: false,
            loader: false,
            form: {
                price: '',
                sync: false,
            }
        };
    },
    props: {
        applyToAllResult: {
            default: false
        },
        filters: {
            default: null
        },
        selected: {
            default: []
        },
        total_item: {
            default: 0
        }
    },
    computed: {
        items_selected() {
            return this.applyToAllResult
                ? this.total_item
                : this.selected.length;
        }
    },
    methods: {
        open() {
            this.display = true;
            this.$store.dispatch('products/setLoader', false);
        },
        action() {
            var price = this.form.price;
            if (!price) return;
            var products = this.selected.map(v => v.id);
            this.loader = true;
            var datas = {
                products,
                price,
                mode: 'price',
                sync: this.form.sync,
            };
            if (this.applyToAllResult) {
                datas.filters = this.filters;
            }
            datas.total_item = this.total_item
            datas.items_selected = this.items_selected
            axios
                .post('/products/bulk', datas)
                .then(r => {
                    this.$emit('saved', r);
                    this.$refs.form.resetFields();
                    this.display = false;
                })
                .catch(() => {})
                .then(() => {
                    this.loader = false;
                });
        }
    }
};
</script>
